import React, {  forwardRef, useCallback } from "react";
import { useSnackbar, SnackbarContent } from "notistack";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import { CardContent, CardHeader, Divider, Grid , Tooltip} from '@mui/material';
import { CancelRounded, CheckCircleOutlineRounded, ErrorOutlineRounded, InfoRounded, WarningAmberRounded } from '@mui/icons-material';

import { SvgDynamicIcon } from 'components/SvgDynamicIcon';
import { blueGrey, green, grey,red } from '@mui/material/colors';
import Exabanque from 'assets/icons/exabanque.png';
import superagent from 'superagent';
import { restIO } from '../../utils/io';


const iconFile = (item) => {
  switch (item) {
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-excel':
      return <SvgDynamicIcon fillColor={green[900]} name="fileExcel" />;
    case 'text/csv':
      return <SvgDynamicIcon fillColor={green[900]} name="fileCsv" />;
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/png':
      return <SvgDynamicIcon fillColor={blueGrey[500]} name="fileImage" />;
    case 'application/pdf':
      return <SvgDynamicIcon fillColor={red[600]} name="filePdf" />;
    case 'application/zip':
      return <SvgDynamicIcon fillColor={grey[500]} name="fileZipper" />;
    case 'application/xml':
    case 'text/xml':
      return <img src={Exabanque} width="20" color="primary" alt={'exabanqueLogo'} />;
    default:
      return <SvgDynamicIcon fillColor={grey[500]} name="file" />;
  }
};


const getStatusIconColor = (status, withIcon = true) => {
  switch (status) {
    case 'success':
      return withIcon ? <CheckCircleOutlineRounded style={{ color: '#4CAF50' }} /> : '#4CAF50';
    case 'error':
      return withIcon ? <ErrorOutlineRounded style={{ color: '#D32F2F' }} /> : '#D32F2F';
    case 'warning':
      return withIcon ? <WarningAmberRounded style={{ color: '#F57C00' }} /> : '#F57C00';
    default:
      return withIcon ? <InfoRounded style={{ color: '#0288D1' }} /> : '#0288D1';
  }
};




const CustomSnackbar = forwardRef(({id,message,subMessage,variant, icon, docs}, ref, ...otherProps) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const handleDownloadAlgo = () => {
    docs.forEach(doc => downloadAlgo(doc, { forceFlagDownload: true }));
    handleDismiss()
  }

  const downloadAlgo = async (doc, { forceFlagDownload = false } = {}) => {

    let blob
    let { fileCombine64, temporaryDownloadUrl, docId, docLabel, docSizeInByte, docTypeCode, docMimeType, docPath, docTypeFlagPopable = true, docTypeFlagMerge } = doc;

    if (forceFlagDownload === true) {
      if(!!docTypeFlagMerge === true) {
        blob =  new Uint8Array(fileCombine64.data);
      }  else {
        let response = await superagent.get(temporaryDownloadUrl).responseType('arraybuffer');
        blob = response.body;
      }
      const streamURL = window.URL.createObjectURL(new Blob([blob], { type: docMimeType ? docMimeType : 'application/octet-stream' }));
      const streamLink = document.createElement('a');
      streamLink.href = streamURL;
      streamLink.setAttribute('download', docLabel);
      document.body.appendChild(streamLink);
      streamLink.click();
      setTimeout(() => {
        document.body.removeChild(streamLink);
        window.URL.revokeObjectURL(streamURL);
      }, 100);
      // archivage Download
      if(docId && docTypeCode) {
        let apiUrl = `${process.env.REACT_APP_PF_URL_PUBLIC}/pf/archivage/docDownload`
        let payload = { docId, docTypeCode };
        await restIO({ endpoint: apiUrl, method: "post", myQuery : {}, payload, jwt: true, });
      }
    }
    if (!!docTypeFlagPopable === true) {

      const streamLink = document.createElement('a');
      streamLink.href = temporaryDownloadUrl;
      streamLink.setAttribute('download', docLabel);
      // if (docLabel.endsWith('.pdf'))

      streamLink.setAttribute('target', '_blank');
      document.body.appendChild(streamLink);
      streamLink.click();
      setTimeout(() => {
        document.body.removeChild(streamLink);
      }, 100);
      // archivage Download
      if(docId && docTypeCode) {
        let apiUrl = `${process.env.REACT_APP_PF_URL_PUBLIC}/pf/archivage/docDownload`
        let payload = {
          docId,
          docTypeCode
        };
        let responseKeepapi = await restIO({
          endpoint: apiUrl,
          method: "post",
          myQuery : {},
          payload,
          jwt: true,
        });
      }
    }
  };

  const buttonText = docs && docs.length > 1 ? "Télécharger les fichiers" : "Télécharger le fichier";
  const allIcons = docs && docs.map(doc => iconFile(doc.docMimeType));

  return (
    <SnackbarContent ref={ref}>
      <Card elevation={4} sx={{minWidth: "300px", maxWidth: "500px", borderLeft: `10px solid ${getStatusIconColor(variant,false)}` }}>
        <Tooltip title={'fermer la notification'}>
          <IconButton sx={{ cursor: 'pointer' ,padding: 0.2,position: 'absolute',right: 0,top: 0, color: getStatusIconColor(variant, false) }}  onClick={handleDismiss}>
            <CancelRounded  />
          </IconButton>
        </Tooltip>
        <CardHeader
          sx={{p:3}}
          avatar={getStatusIconColor(variant)}
          titleTypographyProps={{ color: '#403b65' ,fontSize: '1rem'}}
          title={message}
          subheader={subMessage}
        ></CardHeader>

          <CardActions>
            <Grid container alignItems="center" justifyContent="flex-end">

              {docs && docs.length > 0 &&
                 <Button
                   size={'small'}
                   startIcon={
                     <>
                       {allIcons.length > 1 ? (
                         <React.Fragment>
                           {allIcons.map((icon, index) => (
                             <React.Fragment key={index}>
                               {icon}
                               {index < allIcons.length - 1 && "\u00A0+\u00A0"}
                             </React.Fragment>
                           ))}
                         </React.Fragment>
                       ) : (
                         allIcons[0]
                       )}
                     </>
                   }
                   sx={{
                     borderColor: getStatusIconColor(variant, false),
                     color: getStatusIconColor(variant, false),
                     '&:hover': {
                       backgroundColor: `${getStatusIconColor(variant, false)}0D`,
                       borderColor: `${getStatusIconColor(variant, false)}`,
                     },
                   }}
                   variant={'outlined'}
                   onClick={() => handleDownloadAlgo()}
                 >
                   {buttonText}
                 </Button>
              }
            </Grid>
          </CardActions>
      </Card>
    </SnackbarContent>
  );
});

export default CustomSnackbar;
